/**
 * Created by razial on 24.12.2025.
 */

// hose meta migration from user episode + level to metha + location progress
if (["riddles", "crocword"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 1,

        migrateOnLoad: () => {
            const metaData = cleverapps.dataLoader.load(DataLoader.TYPES.META) || {};

            const current = metaData.current || 0;
            const progress = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_progress`) || 0;

            const userData = cleverapps.dataLoader.load(DataLoader.TYPES.ID) || {};
            const oldCurrent = userData.episode || 0;
            const oldProgress = userData.level || 0;

            if (current !== oldCurrent || progress !== oldProgress) {
                cleverapps.dataLoader.save(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_progress`, oldProgress);

                metaData.current = oldCurrent;

                cleverapps.dataLoader.save(DataLoader.TYPES.META, metaData);
            }
        },

        migrateOnSync: (snapshot) => {
            const current = snapshot.metha && snapshot.metha.current || 0;
            const progress = snapshot.locations && snapshot.locations.progress || 0;

            const oldCurrent = snapshot.users && snapshot.users.episode || 0;
            const oldProgress = snapshot.users && snapshot.users.level || 0;

            if (current !== oldCurrent || progress !== oldProgress) {
                if (!snapshot.metha) {
                    snapshot.metha = {};
                }

                snapshot.metha.current = oldCurrent;

                if (!snapshot.locations) {
                    snapshot.locations = {};
                }

                snapshot.locations.progress = oldProgress;
            }
        }
    }));
}

// hose meta migration to single location
if (["riddles", "crocword"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 2,

        migrateOnLoad: () => {
            const metaData = cleverapps.dataLoader.load(DataLoader.TYPES.META) || {};
            const stage = metaData.current || 0;

            cleverapps.dataLoader.save(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_stage`, stage);
        },

        migrateOnSync: (snapshot) => {
            const stage = snapshot.metha && snapshot.metha.current || 0;

            if (!snapshot.locations) {
                snapshot.locations = {};
            }

            snapshot.locations.stage = stage;
        }
    }));
}

// hose backward compatability
if (["riddles", "crocword"].includes(cleverapps.config.name)) {
    BackwardCompatibility.REGISTRATIONS.add(() => ({
        keys: [DataLoader.TYPES.META, `${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_stage`],

        onSave: (fromSever) => {
            const data = cleverapps.meta.getData();
            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);

            data.current = slot.load("stage") || 0;

            cleverapps.dataLoader.save(DataLoader.TYPES.HOSE, {
                location: data.current,
                progress: slot.load("progress")
            });

            cleverapps.dataLoader.save(DataLoader.TYPES.META, data);

            if (!fromSever) {
                connector.synchronizer.addSendTask("metha");
            }
        },

        onSync: () => {
            const data = cleverapps.meta.getData();
            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);

            data.current = slot.load("stage") || 0;
            data.location = data.current;
            data.progress = slot.load("progress") || 0;

            return data;
        }
    }));
}

// shortmeta migration from user episode + level to metha + location progress
if (["olympics"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 3,

        migrateOnLoad: () => {
            const metaData = cleverapps.dataLoader.load(DataLoader.TYPES.META)
            || cleverapps.dataLoader.load(DataLoader.TYPES.SHORTMETA)
            || cleverapps.dataLoader.load(DataLoader.TYPES.KNOCKOUT)
            || {};

            const current = metaData.current || 0;
            const progress = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_progress`) || 0;

            const userData = cleverapps.dataLoader.load(DataLoader.TYPES.ID) || {};
            const physicalEpisode = userData.episode || 0;
            const physicalLevel = userData.level || 0;
            const physicalProgress = userData.progress || 0;

            const total = physicalEpisode * Level.LEVELS_PER_EPISODE + physicalLevel + physicalProgress;
            const oldCurrent = Math.floor(total / ShortMetaLocation.LEVELS_PER_LOCATION) || 0;
            const oldProgress = (total % ShortMetaLocation.LEVELS_PER_LOCATION) || 0;

            if (current < oldCurrent || current === oldCurrent && progress < oldProgress) {
                cleverapps.dataLoader.save(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_progress`, oldProgress);

                metaData.current = oldCurrent;

                cleverapps.dataLoader.save(DataLoader.TYPES.META, metaData);
            }
        },

        migrateOnSync: (snapshot) => {
            const current = snapshot.metha && snapshot.metha.current || 0;
            const progress = snapshot.locations && snapshot.locations.progress || 0;

            const physicalEpisode = snapshot.users && snapshot.users.episode || 0;
            const physicalLevel = snapshot.users && snapshot.users.level || 0;
            const physicalProgress = snapshot.users && snapshot.users.progress || 0;

            const total = physicalEpisode * Level.LEVELS_PER_EPISODE + physicalLevel + physicalProgress;
            const oldCurrent = Math.floor(total / ShortMetaLocation.LEVELS_PER_LOCATION) || 0;
            const oldProgress = (total % ShortMetaLocation.LEVELS_PER_LOCATION) || 0;

            if (current < oldCurrent || current === oldCurrent && progress < oldProgress) {
                if (!snapshot.metha) {
                    snapshot.metha = {};
                }

                snapshot.metha.current = oldCurrent;

                if (!snapshot.locations) {
                    snapshot.locations = {};
                }

                snapshot.locations.progress = oldProgress;
            }
        }
    }));
}

// shortmeta migration to single location
if (["olympics"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 4,

        migrateOnLoad: () => {
            const metaData = cleverapps.dataLoader.load(DataLoader.TYPES.META) || {};
            const stage = metaData.current || 0;

            cleverapps.dataLoader.save(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_stage`, stage);
        },

        migrateOnSync: (snapshot) => {
            const stage = snapshot.metha && snapshot.metha.current || 0;

            if (!snapshot.locations) {
                snapshot.locations = {};
            }

            snapshot.locations.stage = stage;
        }
    }));
}

// shortmeta backward compatibility
if (["olympics"].includes(cleverapps.config.name)) {
    BackwardCompatibility.REGISTRATIONS.add(() => ({
        keys: [DataLoader.TYPES.META, `${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_stage`],

        onSave: (fromSever) => {
            const data = cleverapps.meta.getData();
            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);

            data.current = slot.load("stage") || 0;

            cleverapps.dataLoader.save(DataLoader.TYPES.META, data);

            if (!fromSever) {
                connector.synchronizer.addSendTask("metha");
            }
        },

        onSync: () => {
            const data = cleverapps.meta.getData();
            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);

            data.current = slot.load("stage") || 0;

            return data;
        }
    }));
}

// farm meta migration to location
if (["heroes"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 5,

        migrateOnLoad: () => {
            const building = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_building`) || 0;
            const keys = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_keys`) || 0;

            const oldFarmData = cleverapps.dataLoader.load(DataLoader.TYPES.FARM) || {};

            let needsMigration = false;

            if (building < (oldFarmData.building || 0)) {
                needsMigration = true;
            }

            if (building === (oldFarmData.building || 0)) {
                const itemsCount = Object.values(keys || {}).reduce((acc, value) => acc + value, 0);
                const oldItemsCount = Object.values(oldFarmData.keys || {}).reduce((acc, value) => acc + value, 0);
                if (itemsCount < oldItemsCount) {
                    needsMigration = true;
                }
            }

            if (needsMigration) {
                cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_keys`, oldFarmData.keys);
                cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_buildings`, oldFarmData.buildings);
                cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_building`, oldFarmData.building);
                cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_quest`, oldFarmData.quest);
                cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_justCollectedDialogue`, oldFarmData.justCollectedDialogue);
            }
        },

        migrateOnSync: (snapshot) => {
            const farmData = snapshot.locations || {};
            const oldFarmData = snapshot.metha || {};

            let needsMigration = false;

            if ((farmData.building || 0) < (oldFarmData.building || 0)) {
                needsMigration = true;
            }

            if ((farmData.building || 0) === (oldFarmData.building || 0)) {
                const itemsCount = Object.values(farmData.keys || {}).reduce((acc, value) => acc + value, 0);
                const oldItemsCount = Object.values(oldFarmData.keys || {}).reduce((acc, value) => acc + value, 0);
                if (itemsCount < oldItemsCount) {
                    needsMigration = true;
                }
            }

            if (needsMigration) {
                snapshot.locations = snapshot.metha;
                snapshot.metha = {};
            }
        }
    }));
}

// farm backward compatibility
if (["heroes"].includes(cleverapps.config.name)) {
    BackwardCompatibility.REGISTRATIONS.add(() => ({
        keys: [DataLoader.TYPES.META, `${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_building`],

        onSave: (fromSever) => {
            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
            const farmData = slot.getLocationInfo();
            cleverapps.dataLoader.save(DataLoader.TYPES.FARM, farmData);

            const metaData = cleverapps.meta.getData();
            cleverapps.dataLoader.save(DataLoader.TYPES.META, metaData);

            if (!fromSever) {
                connector.synchronizer.addSendTask("metha");
            }
        },

        onSync: () => {
            const metaData = cleverapps.meta.getData();

            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
            const farmData = slot.getLocationInfo();

            Object.assign(metaData, farmData);

            return metaData;
        }
    }));
}

// simple meta migration to location
if (["tilehero", "adventure", "differences", "magicwords", "runes", "scramble", "spades", "tripeaks", "woodenblock", "zenmatch"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 6,

        migrateOnLoad: function () {
            const data = cleverapps.dataLoader.load(DataLoader.TYPES.META) || {};
            data.current = data.current || 0;

            const progress = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_progress`);
            data.stars = progress || 0;

            let needsMigration = false;
            needsMigration = this.migrateFromOldData(data, cleverapps.dataLoader.load(DataLoader.TYPES.META) || {}) || needsMigration;
            needsMigration = this.migrateFromOldData(data, cleverapps.dataLoader.load(DataLoader.TYPES.SIMPLE) || {}) || needsMigration;
            needsMigration = this.migrateFromRpg(data, cleverapps.dataLoader.load(DataLoader.TYPES.ID) || {}) || needsMigration;

            if (needsMigration) {
                cleverapps.dataLoader.save(DataLoader.TYPES.META, data);
                cleverapps.dataLoader.save(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_progress`, data.stars);
            }
        },

        migrateOnSync: function (snapshot) {
            const data = cleverapps.clone(snapshot.metha || {}, true);
            data.current = data.current || 0;
            data.stars = snapshot.locations && snapshot.locations.progress || 0;

            let needsMigration = false;
            needsMigration = this.migrateFromOldData(data, snapshot.metha || {}) || needsMigration;
            needsMigration = this.migrateFromRpg(data, snapshot.users || {}) || needsMigration;

            if (needsMigration) {
                snapshot.metha = data;

                if (!snapshot.locations) {
                    snapshot.locations = {};
                }

                snapshot.locations.progress = data.stars;
            }
        },

        migrateFromOldData: function (data, oldData) {
            oldData.current = oldData.current || 0;
            oldData.stars = oldData.stars || 0;

            if (oldData.current > data.current) {
                data.current = oldData.current;
                data.stars = oldData.stars;
                return true;
            }

            if (oldData.current === data.current && oldData.stars > data.stars) {
                data.stars = oldData.stars;
                return true;
            }

            if (oldData.current !== data.current || oldData.stars !== data.stars) {
                return true;
            }
        },

        migrateFromRpg: function (data, userData) {
            if (cleverapps.config.rpg && !data.current && !data.stars && userData.episode > 0) {
                data.current = userData.episode;
                data.stars = 0;
                return true;
            }
        }
    }));
}

// simple meta migration to single location
if (["tilehero", "adventure", "differences", "magicwords", "runes", "scramble", "spades", "tripeaks", "woodenblock", "zenmatch"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 7,

        migrateOnLoad: function () {
            const metaData = cleverapps.dataLoader.load(DataLoader.TYPES.META) || {};
            const stage = metaData.current || 0;

            cleverapps.dataLoader.save(`${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_stage`, stage);
        },

        migrateOnSync: function (snapshot) {
            const stage = snapshot.metha && snapshot.metha.current || 0;

            if (!snapshot.locations) {
                snapshot.locations = {};
            }

            snapshot.locations.stage = stage;
        }
    }));
}

// simple backward compatability
if (["tilehero", "adventure", "differences", "magicwords", "runes", "scramble", "spades", "tripeaks", "woodenblock", "zenmatch"].includes(cleverapps.config.name)) {
    BackwardCompatibility.REGISTRATIONS.add(() => ({
        keys: [DataLoader.TYPES.META, `${DataLoader.TYPES.LOCATION + Meta.SLOT_MAIN}_stage`],

        onSave: (fromSever) => {
            const data = cleverapps.meta.getData();

            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
            const locationData = slot.getLocationInfo();
            data.current = locationData.stage || undefined;
            data.stars = locationData.progress || undefined;

            cleverapps.dataLoader.save(DataLoader.TYPES.SIMPLE, data);
            cleverapps.dataLoader.save(DataLoader.TYPES.META, data);

            if (!fromSever) {
                connector.synchronizer.addSendTask("metha");
                connector.synchronizer.addSendTask("locations");
            }
        },

        onSync: () => {
            const slot = cleverapps.dataSlots.getSlot(Meta.SLOT_MAIN);
            const locationData = slot.getLocationInfo();

            const data = cleverapps.meta.getData();
            data.current = locationData.stage;
            data.stars = locationData.progress;

            return data;
        }
    }));
}

// garden single location
if (["garden"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 8,

        migrateOnLoad: function (migrator) {
            const version = this.loadSlotKey("", "version") || 0;
            const withOldData = this.loadSlotKey("", "stage")
                || this.loadSlotKey("", "details")
                || this.loadSlotKey("", "props")
                || this.loadSlotKey("", "units")
                || this.loadSlotKey("", "map_0", { raw: true })
                || this.loadSlotKey("", "unitslibrary");

            if (version >= 1 || withOldData === undefined || migrator.prevAppVersion && Version.compare(migrator.prevAppVersion, "1.468.0") > 0) {
                return;
            }

            for (const slotId of ["", "1", "2", "3", "4", "5"]) {
                this.resetSlot(slotId);

                const livesData = cleverapps.dataLoader.load(DataLoader.TYPES.LIVES + slotId);
                if (livesData) {
                    cleverapps.dataLoader.remove(DataLoader.TYPES.LIVES + slotId);
                }
            }

            cleverapps.dataLoader.save(DataLoader.TYPES.LIVES, { a: 100 });

            const userData = cleverapps.dataLoader.load(DataLoader.TYPES.ID);
            if (userData) {
                userData.episode = 0;
                userData.level = 0;
                userData.progress = 0;
                userData.exp = 0;
                cleverapps.dataLoader.save(DataLoader.TYPES.ID, userData);
            }

            const forcesData = cleverapps.dataLoader.load(DataLoader.TYPES.FORCES);
            if (forcesData) {
                cleverapps.dataLoader.remove(DataLoader.TYPES.FORCES);
            }

            const offersData = cleverapps.dataLoader.load(DataLoader.TYPES.OFFERS);
            if (offersData) {
                cleverapps.dataLoader.remove(DataLoader.TYPES.OFFERS);
            }

            const unitsShopData = cleverapps.dataLoader.load(DataLoader.TYPES.UNITS_SHOP);
            if (unitsShopData) {
                cleverapps.dataLoader.remove(DataLoader.TYPES.UNITS_SHOP);
            }

            const missionsData = cleverapps.dataLoader.load(DataLoader.TYPES.MISSIONS);
            if (missionsData) {
                cleverapps.dataLoader.remove(DataLoader.TYPES.MISSIONS);
            }

            const metaData = cleverapps.dataLoader.load(DataLoader.TYPES.META);
            if (metaData) {
                cleverapps.dataLoader.remove(DataLoader.TYPES.META);
            }

            migrator.useSingleLocationMigrationNotice = true;
        },

        migrateOnSync: function (snapshot, migrator) {
            const version = snapshot.locations && snapshot.locations.version || 0;
            const withOldData = snapshot.locations && (snapshot.locations.stage
                || snapshot.locations.details
                || snapshot.locations.props
                || snapshot.locations.units
                || snapshot.locations.unitslibrary);

            if (version >= 1 || withOldData === undefined || migrator.prevAppVersion && Version.compare(migrator.prevAppVersion, "1.468.0") > 0) {
                return;
            }

            for (const slotId of ["", "1", "2", "3", "4", "5"]) {
                snapshot[`locations${slotId}`] = {};
                snapshot[`lives${slotId}`] = {};
            }
            snapshot.lives = { a: 100 };

            if (snapshot.users) {
                snapshot.users.episode = 0;
                snapshot.users.level = 0;
                snapshot.users.progress = 0;
                snapshot.users.exp = 0;
            }

            if (snapshot.forces) {
                snapshot.forces.forces = 0;
            }

            if (snapshot.offers) {
                snapshot.offers = {};
            }

            if (snapshot.unitsshop) {
                snapshot.unitsshop = {};
            }

            if (snapshot.missions) {
                snapshot.missions = [];
            }

            if (snapshot.metha) {
                snapshot.metha = {};
            }

            migrator.useSingleLocationMigrationNotice = true;
        },

        loadSlotKey: function (slotId, key, options) {
            return cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION + slotId}_${key}`, options);
        },

        resetSlot: function (slotId) {
            cleverapps.dataLoader.listExistingKeys(`${DataLoader.TYPES.LOCATION + slotId}_`).forEach((storageKey) => {
                cleverapps.dataLoader.remove(storageKey);
            });
        }
    }));
}

// migration to new customers format
if (["mergecraft", "wondermerge", "fairy", "hustlemerge"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => {
        const SLOTS_IDS = ["0", "1", "2", "3", "4", "5"];
        const MAX_MAP_SIZES = [100, 100];
        const UNIT_TYPES_DICTIONARY = {
            "dwarf": "hero",
            "king": "hero",
            "bear": "hero",
            "elf": "hero",
            "warlock": "hero",
            "troll": "hero",
            "knight": "hero",
            "hunter": "hero",
            "centaur": "hero",
            "gnomes": "hero",
            "shark": "hero",
            "fish": "hero",
            "panda": "hero",
            "priestess": "hero",
            "magician": "hero",
            "bard": "hero"
        };

        function migrateCustomer(expedition, unit) {
            let recipesDictionary = CustomerRecipes[expedition];
            if (!recipesDictionary) {
                return false;
            }
            const unitKey = Unit.GetKey(unit);
            const unitType = UNIT_TYPES_DICTIONARY[unit.code];
            recipesDictionary = recipesDictionary[unitType] || recipesDictionary[unitKey];
            if (!recipesDictionary) {
                return false;
            }

            let recipe = recipesDictionary[unit.ri];
            if (!recipe) {
                return false;
            }

            recipe = { ...recipe };

            if (typeof recipe.cookingDuration === "string") {
                recipe.cookingDuration = cleverapps.parseInterval(recipe.cookingDuration);
            }

            unit.rp = CustomerRecipe.encode(recipe);
            return true;
        }

        return {
            version: 10,

            migrateOnLoad: () => {
                const platformPrefix = cleverapps.config.name + connector.platform.getLocalStoragePrefix();

                SLOTS_IDS.forEach((slotId) => {
                    let expedition = "main";

                    if (slotId !== "0") {
                        const mapData = cleverapps.dataLoader.load(`${platformPrefix}_level_0x${slotId}`);
                        expedition = mapData && mapData.expedition;
                    }

                    if (!expedition) {
                        return;
                    }

                    let mapPrefix = `${platformPrefix}_map`;
                    if (slotId !== "0") {
                        mapPrefix += `_${slotId}_`;
                    }

                    for (let x = 0; x < MAX_MAP_SIZES[0]; x++) {
                        for (let y = 0; y < MAX_MAP_SIZES[1]; y++) {
                            const unit = cleverapps.dataLoader.load(`${mapPrefix}${x}_${y}`);
                            if (unit && unit.ri !== undefined) {
                                const success = migrateCustomer(expedition, unit);
                                if (success) {
                                    cleverapps.dataLoader.save(`${mapPrefix}${x}_${y}`, unit);
                                }
                            }
                        }
                    }
                });
            },

            migrateOnSync: (snapshot) => {
                SLOTS_IDS.forEach((slotId) => {
                    let expedition = "main";

                    if (slotId !== "0") {
                        const mapData = snapshot[`games${slotId}`];
                        expedition = mapData && mapData.expedition;
                    }

                    if (!expedition) {
                        return;
                    }

                    const units = snapshot[`units${slotId === "0" ? "" : slotId}`];
                    if (!units) {
                        return;
                    }

                    Object.entries(units).forEach(([key, value]) => {
                        if (key === "intact") {
                            return;
                        }
                        if (typeof value === "object") {
                            // do nothing - too old format
                        } else if (typeof value === "string" && value.charAt(0) === "{") {
                            // do nothing - too old format
                        } else {
                            let changed = false;
                            value = UnitPacker.compactUnits(UnitPacker.expandUnits(value, key).map((unit) => {
                                if (unit && unit.ri !== undefined) {
                                    migrateCustomer(expedition, unit);
                                    changed = true;
                                }
                                return unit;
                            }));
                            if (changed) {
                                units[key] = value;
                            }
                        }
                    });
                });
            }
        };
    });
}

// migration for opened fogs
if (["mergecraft", "wondermerge", "fairy", "hustlemerge"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 11,

        migrateOnLoad: (migrator) => {
            if (Version.compare(migrator.prevAppVersion, "1.469.1") >= 0) {
                return;
            }

            ["0", "1", "2", "3", "4", "5"].forEach((slotId) => {
                const gameKey = `${cleverapps.dataLoader.getLocalStoragePrefix()}_level_0x${slotId}`;
                const gameData = cleverapps.dataLoader.load(gameKey);
                if (gameData && gameData.opened !== undefined) {
                    delete gameData.opened;
                    cleverapps.dataLoader.save(gameKey, gameData);
                }
            });
        },

        migrateOnSync: (snapshot, migrator) => {
            if (Version.compare(migrator.prevAppVersion, "1.469.1") >= 0) {
                return;
            }

            ["0", "1", "2", "3", "4", "5"].forEach((slotId) => {
                const gameData = snapshot[`games${slotId}`];
                if (gameData && gameData.opened !== undefined) {
                    delete gameData.opened;
                }
            });
        }
    }));
}

// migration from old syncer format after removing server migrations
if (["mergecraft", "wondermerge", "fairy", "hustlemerge"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 12,

        migrateOnLoad: () => {
            // do nothing
        },

        migrateOnSync: (snapshot) => {
            ["0", "1", "2", "3", "4", "5"].forEach((slotId) => {
                let expedition = "main";

                if (slotId !== "0") {
                    const mapData = snapshot[`games${slotId}`];
                    expedition = mapData && mapData.expedition;
                }

                if (!expedition) {
                    return;
                }

                const units = snapshot[`units${slotId === "0" ? "" : slotId}`];
                if (!units) {
                    return;
                }

                Object.entries(units).forEach(([key, value]) => {
                    let data;

                    if (typeof value === "object") {
                        data = value;
                    } else if (typeof value === "string" && value.charAt(0) === "{") {
                        data = JSON.parse(value);
                    }

                    if (!data) {
                        return;
                    }

                    let changed = false;

                    Object.keys(data).forEach((key) => {
                        const position = Unit.ParsePositionKey(key);
                        if (position.x === undefined || position.y === undefined) {
                            return;
                        }

                        const value = data[key];
                        if (value.x !== undefined || value.y !== undefined) {
                            return;
                        }

                        changed = true;
                        value.x = position.x;
                        value.y = position.y;
                    });

                    if (changed) {
                        units[key] = data;
                    }
                });
            });
        }
    }));
}

// simple meta stage cap - fix out-of-range stages that appeared due to missing cap in setStage or wrong migration
if (["tilehero", "adventure", "differences", "magicwords", "runes", "scramble", "spades", "tripeaks", "woodenblock", "zenmatch"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 13,

        migrateOnLoad: function () {
        },

        migrateOnSync: function () {
        }
    }));
}

// soft to hard + scale hard
DataVersion.registerSoftToHardConversion({
    forward: ["woodenblock", "zenmatch"],
    back: ["woodenblock", "zenmatch"]
});

// migrate achievements from numeric bitmask to base64 string format
if (["mergecraft", "wondermerge", "fairy", "hustlemerge", "heroes", "riddles", "adventure", "runes"].includes(cleverapps.config.name)) {
    DataVersion.MIGRATIONS.add(() => ({
        version: 15,

        migrateOnLoad: function () {
            const existing = cleverapps.dataLoader.load(DataLoader.TYPES.ACHIEVEMENTS);
            if (!existing || typeof existing === "string") {
                return;
            }
            cleverapps.dataLoader.save(DataLoader.TYPES.ACHIEVEMENTS, cleverapps.toBitBase64(cleverapps.fromBit(existing)));
        },

        migrateOnSync: function (snapshot) {
            if (!snapshot.achievements || typeof snapshot.achievements === "string") {
                return;
            }
            snapshot.achievements = cleverapps.toBitBase64(cleverapps.fromBit(Number(snapshot.achievements)));
        }
    }));
}

// migrate landmark bitmask from unitslibrary to achievements
// 18 re-runs 17: after 17 had already run, a session on a cached pre-1.484.0 build
// (seen on facebook and instant, where cached builds live the longest) could wipe landmark bits -
// old AchievementsConfig had no landmark ids and load() did not preserve unknown ids yet, so save() dropped them,
// while dataversion stayed 17 and the repair never re-applied; unitslibrary is intact, restore from it once more
if (["mergecraft", "wondermerge", "fairy", "hustlemerge"].includes(cleverapps.config.name)) {
    [17, 18].forEach((version) => {
        DataVersion.MIGRATIONS.add(() => ({
            version,

            migrateOnLoad: function () {
                const libData = cleverapps.dataLoader.load(DataLoader.TYPES.UNITS_LIBRARY);
                const landmarkBits = libData && libData.opened && libData.opened.landmark;
                if (!landmarkBits) {
                    return;
                }
                const existing = cleverapps.dataLoader.load(DataLoader.TYPES.ACHIEVEMENTS);
                const landmarkStages = cleverapps.fromBit(landmarkBits).map((landmarkStage) => landmarkStage + 10);
                const existingIds = existing ? cleverapps.fromBitBase64(existing) : [];
                const ids = [...new Set(existingIds.concat(landmarkStages))];
                cleverapps.dataLoader.save(DataLoader.TYPES.ACHIEVEMENTS, cleverapps.toBitBase64(ids));
            },

            migrateOnSync: function (snapshot) {
                const libData = snapshot.unitslibrary;
                const landmarkBits = libData && libData.opened && libData.opened.landmark;
                if (!landmarkBits) {
                    return;
                }
                const landmarkStages = cleverapps.fromBit(landmarkBits).map((stage) => stage + 10);
                const existingIds = snapshot.achievements ? cleverapps.fromBitBase64(snapshot.achievements) : [];
                const ids = [...new Set(existingIds.concat(landmarkStages))];
                snapshot.achievements = cleverapps.toBitBase64(ids);
            }
        }));
    });
}

// garden / ladacha game level migration: derive currentPhysicalLevel.level and exp from location continuous stage
(function () {
    const nextLevelThreshold = function (level, threshold) {
        if (level <= threshold.length - 1) {
            return threshold[level];
        }
        const d = level - (threshold.length - 1);
        const lastStep = threshold[threshold.length - 1] - threshold[threshold.length - 2];
        return threshold[threshold.length - 1] + lastStep * d;
    };

    const computeLevelAndExp = function (continuousStage) {
        const threshold = GameLevelConfig.main.threshold;
        const EXP_FOR_FIX = 10;
        let level = 0;
        let exp = 0;
        for (let i = 0; i < continuousStage; i++) {
            exp += EXP_FOR_FIX;
            const next = nextLevelThreshold(level, threshold);
            if (exp >= next) {
                exp -= next;
                level++;
            }
        }
        return { level, exp };
    };

    if (cleverapps.config.name === "garden") {
        DataVersion.MIGRATIONS.add(() => {
            const getStagesInRoom = function (roomNo) {
                const bundle = bundles[`building_${roomNo}_0`];
                return bundle && bundle.meta && bundle.meta.stages || 0;
            };

            const computeContinuousStage = function (roomNo, stageNo) {
                let total = 0;
                for (let r = 0; r < roomNo; r++) {
                    total += getStagesInRoom(r);
                }
                return total + (stageNo || 0);
            };

            return {
                version: 18,

                migrateOnLoad: function () {
                    const roomNo = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION}_room`) || 0;
                    const stageNo = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION}_stage`) || 0;
                    const { level, exp } = computeLevelAndExp(computeContinuousStage(roomNo, stageNo));

                    const userData = cleverapps.dataLoader.load(DataLoader.TYPES.ID);
                    if (userData) {
                        userData.level = level;
                        userData.exp = exp;
                        cleverapps.dataLoader.save(DataLoader.TYPES.ID, userData);
                    }
                },

                migrateOnSync: function (snapshot) {
                    const locations = snapshot.locations || {};
                    const roomNo = locations.room || 0;
                    const stageNo = locations.stage || 0;
                    const { level, exp } = computeLevelAndExp(computeContinuousStage(roomNo, stageNo));

                    if (snapshot.users) {
                        snapshot.users.level = level;
                        snapshot.users.exp = exp;
                    }
                }
            };
        });
    }

    if (cleverapps.config.name === "ladacha") {
        DataVersion.MIGRATIONS.add(() => {
            const getBuildingsInRoom = function (roomNo) {
                const bundle = bundles[`room_${roomNo}`];
                return bundle && bundle.meta && bundle.meta.stages || 0;
            };

            const getStagesInBuilding = function (roomNo, buildingNo) {
                const bundle = bundles[`building_${roomNo}_${buildingNo}`];
                return bundle && bundle.meta && bundle.meta.stages || 0;
            };

            const computeContinuousStage = function (roomNo, buildingNo, stageNo) {
                let total = 0;
                for (let r = 0; r < roomNo; r++) {
                    const buildings = getBuildingsInRoom(r);
                    for (let b = 0; b < buildings; b++) {
                        total += getStagesInBuilding(r, b);
                    }
                }
                for (let b = 0; b < (buildingNo || 0); b++) {
                    total += getStagesInBuilding(roomNo, b);
                }
                return total + (stageNo || 0);
            };

            return {
                version: 18,

                migrateOnLoad: function () {
                    const roomNo = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION}_room`) || 0;
                    const buildingNo = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION}_building`) || 0;
                    const stageNo = cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION}_stage`) || 0;
                    const { level, exp } = computeLevelAndExp(computeContinuousStage(roomNo, buildingNo, stageNo));

                    const userData = cleverapps.dataLoader.load(DataLoader.TYPES.ID);
                    if (userData) {
                        userData.level = level;
                        userData.exp = exp;
                        cleverapps.dataLoader.save(DataLoader.TYPES.ID, userData);
                    }
                },

                migrateOnSync: function (snapshot) {
                    const locations = snapshot.locations || {};
                    const roomNo = locations.room || 0;
                    const buildingNo = locations.building || 0;
                    const stageNo = locations.stage || 0;
                    const { level, exp } = computeLevelAndExp(computeContinuousStage(roomNo, buildingNo, stageNo));

                    if (snapshot.users) {
                        snapshot.users.level = level;
                        snapshot.users.exp = exp;
                    }
                }
            };
        });
    }
}());
